import { ScalingModeEnum, TransitionTypeEnum } from 'api';
import { ScalingType } from 'types/Scene';
import { TransitionType } from 'types/Transitions';

export const downloadFile = (filename: string, url: string | Object) => {
  const a = document.createElement('a');
  a.setAttribute('download', filename);

  if (typeof url === 'string') {
    a.setAttribute('href', url);
  } else {
    const file = new Blob([JSON.stringify(url)], { type: 'text/json' });
    a.setAttribute('href', URL.createObjectURL(file));
  }

  a.click();
};

export const convertScalingModeFromApi = (scalingMode: ScalingModeEnum): ScalingType => {
  switch (scalingMode) {
    case ScalingModeEnum.Fit:
      return ScalingType.FIT;
    case ScalingModeEnum.Fill:
      return ScalingType.FILL;
    default:
      break;
  }
};

export const convertTransitionFromApi = (transitionType: TransitionTypeEnum): TransitionType => {
  switch (transitionType) {
    case TransitionTypeEnum.Fade:
      return TransitionType.Fade;
    case TransitionTypeEnum.WipeDiagonal:
      return TransitionType.WipeDiagonal;
    default:
      return TransitionType.None;
  }
};

export const getUrlParametr = (param: string) => {
  const url = new URLSearchParams(window.location.search);
  return url.get(param);
};

export const hasUrlParametr = (param: string) => {
  const url = new URLSearchParams(window.location.search);
  return url.has(param);
};

export const getCanvasBlob = (
  canvas: HTMLCanvasElement,
  mimeType: string,
  quality: number
): Promise<Blob | null> =>
  new Promise(resolve => {
    canvas.toBlob(blob => resolve(blob), mimeType, quality);
  });

export const shuffleVideos = (
  arrA: Array<any>,
  arrB: Array<any>,
  shuffleNumber: number
): Array<any> => {
  if (shuffleNumber <= 0) return arrA;

  let iB = 0;
  let iR = 0;
  const res = [];

  for (let iA = 0; iA < arrA.length; iA++) {
    if (iA > 0 && iA % (shuffleNumber - 1) === 0 && arrB[iB] !== undefined) {
      res[iR] = arrB[iB];
      iR++;
      iB++;
      res[iR] = arrA[iA];
    } else {
      res[iR] = arrA[iA];
    }
    iR++;
  }

  return res.concat(arrB.slice(iB));
};
